import http from '~/http/services/pos';
import { ApiResponse } from '~/types/Api';
import { Cashier } from '~/types/Cashier';
import { CashierBalancing } from '~/types/CashierBalancing';

const CASHIER_URL = '/api/v1/cashier';
const CASHIER_BALANCINGS_URL = '/api/v1/cashier-balancings';

type GetCashierResponse = ApiResponse<Cashier>;
export const getCashier = () => {
  return http.get<GetCashierResponse>(`${CASHIER_URL}`);
};

type OpenCashierResponse = ApiResponse<null>;
export const openCashier = (body: { balance: number }) => {
  return http.post<OpenCashierResponse>(`${CASHIER_URL}/open`, body);
};

type CloseCashierResponse = ApiResponse<{ id: string }>;
export const closeCashier = (body: { balance: number }) => {
  return http.post<CloseCashierResponse>(`${CASHIER_URL}/close`, body);
};

type GetCashierBalancingsResponse = ApiResponse<CashierBalancing[]>;
export const getCashierBalancings = (date: string) => {
  return http.get<GetCashierBalancingsResponse>(
    `${CASHIER_BALANCINGS_URL}?date=${date}`
  );
};
